export const DEFAULT_TARGETING_KEYS = ['s1', 's2', 's3', 'pid', 'pos'] as const;
